import ColorPicker from "components/CharacterApp/interface/ColorPicker";
import {useCallback} from "react";
import {useCharacterParams} from "contexts/CharacterParams";
import {useSuitColors} from "hooks/useCharacterMaterials";
import CharacterTabsPanel, {CharacterTabsPanelFooter} from "components/CharacterApp/interface/CharacterTabs/CharacterTabsPanel";

export default function BadgeColorTab() {
  const { colors, setColor } = useCharacterParams();
  const availableColors = useSuitColors();

  const handleChange = useCallback((color) => {
    setColor('badge', color);
  }, [setColor]);

  return <CharacterTabsPanel value={'badge'}>
    <ColorPicker colors={availableColors} color={colors.badge} onChange={handleChange} allowSlider={false}/>
    <CharacterTabsPanelFooter>
      <ColorPicker colors={availableColors} color={colors.badge} onChange={handleChange} allowSwatches={false}/>
    </CharacterTabsPanelFooter>
  </CharacterTabsPanel>
}
